"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKFLOW = exports.WORDPRESS = exports.WEBSITE = exports.WEBINAR = exports.VIDEO = exports.TICKETING = exports.SURVEY = exports.SOCIAL = exports.SEO = exports.SCHEDULING = exports.SALES = exports.PROJECT = exports.PPC = exports.PAYROLL = exports.LIVE_CHAT = exports.LEAD_GEN = exports.KNOWLEDGE_BASE = exports.IPAAS = exports.HELP_DESK = exports.EVENT = exports.ERP = exports.EMAIL = exports.ECOMMERCE = exports.DATA_MANAGEMENT = exports.CRM = exports.CMS = exports.CALL_CENTER = exports.AUTOMATION = exports.ANALYTICS = exports.ACCOUNTING = exports.ABM = void 0;
var ABM = 'ABM';
exports.ABM = ABM;
var ACCOUNTING = 'ACCOUNTING';
exports.ACCOUNTING = ACCOUNTING;
var ANALYTICS = 'ANALYTICS';
exports.ANALYTICS = ANALYTICS;
var AUTOMATION = 'AUTOMATION';
exports.AUTOMATION = AUTOMATION;
var CALL_CENTER = 'CALL_CENTER';
exports.CALL_CENTER = CALL_CENTER;
var CMS = 'CMS';
exports.CMS = CMS;
var CRM = 'CRM';
exports.CRM = CRM;
var DATA_MANAGEMENT = 'DATA_MANAGEMENT';
exports.DATA_MANAGEMENT = DATA_MANAGEMENT;
var ECOMMERCE = 'ECOMMERCE';
exports.ECOMMERCE = ECOMMERCE;
var EMAIL = 'EMAIL';
exports.EMAIL = EMAIL;
var ERP = 'ERP';
exports.ERP = ERP;
var EVENT = 'EVENT';
exports.EVENT = EVENT;
var HELP_DESK = 'HELP_DESK';
exports.HELP_DESK = HELP_DESK;
var IPAAS = 'IPAAS';
exports.IPAAS = IPAAS;
var KNOWLEDGE_BASE = 'KNOWLEDGE_BASE';
exports.KNOWLEDGE_BASE = KNOWLEDGE_BASE;
var LEAD_GEN = 'LEAD_GEN';
exports.LEAD_GEN = LEAD_GEN;
var LIVE_CHAT = 'LIVE_CHAT';
exports.LIVE_CHAT = LIVE_CHAT;
var PAYROLL = 'PAYROLL';
exports.PAYROLL = PAYROLL;
var PPC = 'PPC';
exports.PPC = PPC;
var PROJECT = 'PROJECT';
exports.PROJECT = PROJECT;
var SALES = 'SALES';
exports.SALES = SALES;
var SCHEDULING = 'SCHEDULING';
exports.SCHEDULING = SCHEDULING;
var SEO = 'SEO';
exports.SEO = SEO;
var SOCIAL = 'SOCIAL';
exports.SOCIAL = SOCIAL;
var SURVEY = 'SURVEY';
exports.SURVEY = SURVEY;
var TICKETING = 'TICKETING';
exports.TICKETING = TICKETING;
var VIDEO = 'VIDEO';
exports.VIDEO = VIDEO;
var WEBINAR = 'WEBINAR';
exports.WEBINAR = WEBINAR;
var WEBSITE = 'WEBSITE';
exports.WEBSITE = WEBSITE;
var WORDPRESS = 'WORDPRESS';
exports.WORDPRESS = WORDPRESS;
var WORKFLOW = 'WORKFLOW';
exports.WORKFLOW = WORKFLOW;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/Category.js
// module id = 54
// module chunks = 209 210 211 212 213